<template lang="">
  <div class="d-flex flex-column justify-content-start container-category">
    <base-link
      v-element-hover="onHover"
      :to="category.links && category.links.self ? category.links.self : '/'"
    >
      <div
        class="border border-light-subtle rounded rounded-4 mb-2 position-relative w-100 category bg-"
      >
        <Transition name="scale">
          <div
            v-if="isHovered"
            class="bg-body-secondary w-100 h-100 rounded rounded-4"
          />
        </Transition>
        <i
          v-if="category.iconSwiper"
          class="bi fs-2 position-absolute top-50 start-50 translate-middle mx-auto"
          :class="[isHovered ? 'text-secondary' : '', category.iconSwiper]"
        />
        <div v-else>
          <img
            v-if="!imageErrors"
            v-lazy="
              category.image ? category.image : category.attributes?.image
            "
            class="position-absolute top-50 start-50 translate-middle image-category mx-auto px-2"
            @error="imageErrors = true"
          />
        </div>
      </div>
      <div
        class="col d-flex justify-content-center align-items-center link-animation-right"
      >
        <span class="text-secondary p-1 p-xl-2">
          {{ category.name }}
        </span>
        <Transition name="fade-right">
          <i
            v-if="isHovered"
            class="bi bi-chevron-right"
            :class="[isHovered ? 'text-secondary' : '', category.iconSwiper]"
          />
        </Transition>
      </div>
    </base-link>
  </div>
</template>
<script lang="ts">
import BaseLink from "~/components/buttons/BaseLink.vue";
import { vElementHover } from "@vueuse/components";
import { getTitleTranslate, getFinalEshopUrl } from "@/utils/general";
export default {
  directives: {
    "element-hover": vElementHover,
  },
  components: {
    BaseLink,
  },
  props: {
    category: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      imageErrors: false as boolean,
      isHovered: false as boolean,
    };
  },
  methods: {
    getFinalUrl(path: string) {
      return getFinalEshopUrl(path);
    },
    getTitle(section: string, name: string) {
      return getTitleTranslate(section, name);
    },
    onHover(state: boolean) {
      this.isHovered = state;
    },
  },
};
</script>
<style lang="sass" scoped>
.category
    height: 120px
    @media (min-width: 992px)
        height: 200px
.image-category
    max-width: 100%
    object-fit: contain
    height: 100px
    @media (min-width: 992px)
        height: 160px

.scale-enter-active,
.scale-leave-active
    transition: all 0.3s ease-in-out

.scale-enter-from,
.scale-leave-to
    transform: scale(0.5)
    opacity: 0

.fade-right-enter-active,
.fade-right-leave-active
    transition: all 0.2s ease

.fade-right-enter-from,
.fade-right-leave-to
    opacity: 0
    transform: translateX(-16px)

.container-category .link-animation-right span
    transition: all 0.3s ease-out

.container-category:hover .link-animation-right span
    transform: translateX(-3px)
    transition: all 0.3s ease-out
</style>
